<procure-input-select
  [control]="control()"
  [appendTo]="appendTo()"
  [label]="label()"
  [hint]="hint()"
  [bindLabel]="bindLabel()"
  [groupBy]="groupBy()"
  [items]="items()"
  [clearAllText]="clearAllText()"
  [showMode]="showMode()"
  [optionTemplate]="option"
/>

<ng-template
  #option
  let-item
>
  {{ item.getDisplay() }}
  <span class="input-contacts__info">
    @if (item.isActive === false) {
      <span>[Inactive]</span>
    }
    <span>{{ item.function ? `${item.function}, ` : "" }}</span>
    <span>Latest Response: {{ (item.supplierContactKpi?.latestResponseTime | date) || "-" }}</span>
  </span>
</ng-template>
